// extracted by mini-css-extract-plugin
var _1 = "BALevelCarouselV2-module__card--gVtNN";
var _2 = "BALevelCarouselV2-module__cardSlot--AfGs5";
var _3 = "BALevelCarouselV2-module__chevronButton--eFWwE";
var _4 = "BALevelCarouselV2-module__container--mwcvX";
var _5 = "BALevelCarouselV2-module__description--YI75L";
var _6 = "BALevelCarouselV2-module__levelIcon--nY8U9";
var _7 = "BALevelCarouselV2-module__levelLabel--Jufov";
var _8 = "BALevelCarouselV2-module__recommendation--V7Riy BALevelCarouselV2-module__description--YI75L";
var _9 = "BALevelCarouselV2-module__recommendationMismatch--jg8Am BALevelCarouselV2-module__recommendation--V7Riy BALevelCarouselV2-module__description--YI75L";
var _a = "BALevelCarouselV2-module__srOnly--AQXKi";
var _b = "BALevelCarouselV2-module__track--fS4t_";
var _c = "BALevelCarouselV2-module__viewport--zkCWC";
export { _1 as "card", _2 as "cardSlot", _3 as "chevronButton", _4 as "container", _5 as "description", _6 as "levelIcon", _7 as "levelLabel", _8 as "recommendation", _9 as "recommendationMismatch", _a as "srOnly", _b as "track", _c as "viewport" }
